export const DESTINATIONS = [
    {
        region: "North America (The High-Value Hubs)",
        countries: ["USA", "Canada"]
    },
    {
        region: "Europe (The Diversity Tier)",
        countries: ["United Kingdom", "Ireland", "Germany", "France", "Netherlands", "Spain", "Italy", "Sweden", "Switzerland", "Finland", "Poland", "Malta"]
    },
    {
        region: "Asia-Pacific (The Growth Tier)",
        countries: ["Australia", "New Zealand", "Malaysia", "Singapore", "United Arab Emirates", "Japan", "South Korea", "Hong Kong (SAR)", "China"]
    }
];

export const CITY_LIST: Record<string, string[]> = {
    "United Kingdom": ["London", "Manchester", "Birmingham", "Leeds", "Bristol", "Sheffield", "Liverpool", "Nottingham", "Newcastle", "Oxford", "Cambridge", "Edinburgh", "Glasgow", "Aberdeen", "Dundee", "Cardiff", "Swansea", "Belfast"],
    "USA": ["New York City", "Boston", "Philadelphia", "Washington D.C.", "Atlanta", "Miami", "Chicago", "Detroit", "Minneapolis", "St. Louis", "Los Angeles", "San Francisco", "Seattle", "San Diego", "Portland", "Houston", "Dallas", "Austin", "Phoenix", "Denver"],
    "Australia": ["Sydney", "Melbourne", "Brisbane", "Perth", "Adelaide", "Canberra", "Gold Coast", "Hobart", "Darwin"],
    "Canada": ["Toronto", "Ottawa", "Hamilton", "London (ON)", "Windsor", "Vancouver", "Victoria", "Kelowna", "Montreal", "Quebec City", "Calgary", "Edmonton", "Winnipeg", "Halifax"],
    "Germany": ["Berlin", "Munich", "Hamburg", "Frankfurt", "Cologne"],
    "France": ["Paris", "Lyon", "Toulouse", "Montpellier"],
    "Netherlands": ["Amsterdam", "Rotterdam", "Utrecht", "Eindhoven"],
    "Ireland": ["Dublin", "Cork", "Galway", "Limerick"],
    "Spain": ["Madrid", "Barcelona"],
    "Italy": ["Milan", "Rome"],
    "Sweden": ["Stockholm"],
    "Switzerland": ["Zurich"],
    "Malaysia": ["Kuala Lumpur", "George Town (Penang)", "Johor Bahru", "Shah Alam", "Subang Jaya", "Cyberjaya (Tech Hub)"]
};

export const DEGREE_LEVELS = [
    {
        category: "Foundation & Pathway",
        levels: ["International Foundation Year (IFY)", "International Year One (Fast-track)", "Pathway to Bachelor's"]
    },
    {
        category: "Undergraduate",
        levels: ["Bachelor's Degree (3 or 4 Year)", "Integrated Master's (Bachelors + Masters)", "Higher National Diploma (HND)"]
    },
    {
        category: "Postgraduate",
        levels: ["Master's Degree", "Postgraduate Diploma / Certificate (PGDip/PGCert)", "Pre-Master's Program"]
    },
    {
        category: "Doctorate & Research",
        levels: ["PhD / Doctorate", "MPhil / Master's by Research"]
    },
    {
        category: "Professional",
        levels: ["Medicine / MBBS / MD", "DVM (Veterinary)"]
    }
];

export const COURSE_CATEGORIES = [
    { category: "Business & Finance", subCourses: ["MBA", "Accounting", "Finance", "Marketing", "International Business", "Supply Chain", "Entrepreneurship"] },
    { category: "IT & Computer Science", subCourses: ["AI & Machine Learning", "Cybersecurity", "Data Analytics", "Software Engineering", "Game Design", "IT Management"] },
    { category: "Engineering", subCourses: ["Civil", "Mechanical", "Electrical", "Aerospace", "Chemical", "Biomedical", "Automotive Engineering"] },
    { category: "Health & Medicine", subCourses: ["Medicine (MBBS)", "Nursing", "Pharmacy", "Public Health", "Physiotherapy", "Biotechnology", "Nutrition"] },
    { category: "Sciences & Math", subCourses: ["Physics", "Chemistry", "Biology", "Environmental Science", "Mathematics", "Actuarial Science", "Forensic Science"] },
    { category: "Social Sciences", subCourses: ["Psychology", "Economics", "International Relations", "Sociology", "Political Science", "Criminology"] },
    { category: "Arts & Humanities", subCourses: ["Fine Arts", "Graphic Design", "Architecture", "Fashion", "Media & Communications", "Linguistics", "History"] },
    { category: "Law & Legal", subCourses: ["LLB (Law)", "International Law", "Corporate Law", "Criminal Justice", "Human Rights Law"] },
    { category: "Hospitality & Tourism", subCourses: ["Hotel Management", "Culary Arts", "Event Management", "Travel & Tourism", "Luxury Brand Management"] },
    { category: "Agriculture & Environment", subCourses: ["Agribusiness", "Sustainable Development", "Forestry", "Marine Biology", "Veterinary Science"] }
];

export const ACADEMIC_STREAMS = ["Science", "Commerce/Business", "Humanities/Arts", "Engineering", "Medicine/Healthcare"];
export const QUALIFICATIONS = ["High School (12th Grade)", "Diploma", "Bachelor's Degree", "Master's Degree"];
export const ENGLISH_TESTS = ["IELTS", "TOEFL", "PTE", "Duolingo", "None/Haven't taken yet", "Medium of Instruction (MOI) letter"];
export const STANDARDIZED_TESTS = ["GRE", "GMAT", "SAT", "ACT"];
export const WORK_EXPERIENCE = ["None", "Under 1 year", "1-3 years", "3-5 years", "5+ years"];
export const INTAKES = ["Earliest Possible", "Fall (Sept/Oct)", "Winter (Jan/Feb)", "Summer (May/June)"];
export const SCHOLARSHIPS = ["No (Self-funded)", "Yes (Partial - 20-50%)", "Yes (High Priority - 50%+)"];
